import de from "./de";

let fi = {
    "values": {
        "buttons:flipper" : "Flip puolin hallituksen",
        "buttons:first" : "Mene ensimmäinen siirto",
        "buttons:prev" : "Mene edellisen siirron",
        "buttons:next" : "Mene seuraavaa siirtoa",
        "buttons:play" : "Toista / lopettaa pelaamisen kaikki liikkuu",
        "buttons:last" : "Siirry viimeiseen liikkua",
        "buttons:deleteVar" : "Poista vaihtelu",
        "buttons:promoteVar" : "Edistää vaihtelu",
        "buttons:deleteMoves" : "Poista loput liikkuu täältä",
        "buttons:nags" : "NAGs menu",
        "buttons:pgn" : "Näyttö PGN nykyisen pelin",
        "buttons:hidePGN" : "Piilota näytössä PGN",
        "chess:q": "D",
        "chess:k": "K",
        "chess:r": "T",
        "chess:b": "L",
        "chess:n": "R",
        "chess:Q": "D",
        "chess:K": "K",
        "chess:R": "T",
        "chess:B": "L",
        "chess:N": "R"
    }
}

export default fi;